const brSplit = {
  split: {
    label: {
      host: 'Host',
      vendor: 'Vendor',
      hauseful: 'Hauseful',
      partner: 'Partner',
      tax: 'Tax',
      taxes: 'Taxes',
      mode: 'Mode',
      description: 'Description',
      hostTakeRate: 'Host take rate',
      customerTakeRate: 'Customer take rate',
      hausefulTakeRate: 'Hauseful take rate',
      partnerTakeRate: 'Partner take rate',
      fixAmount: 'Fixed amount',
      percentage: 'Percentage',
      monetary: 'Monetary',
      active: 'active',
      inactive: 'inactive',
      customer: 'Customer',
    },

    hints: {
      delete: 'Do you really want to delete this configuration?',
    },

    action: {
      cancel: 'Cancel',
      delete: 'Delete split configuration',
      edit: 'Edit split configuration',
      create: 'Create split configuration',
      loading: 'Loading split configuration',
    },

    messages: {
      successfullyCreated: 'Split configuration created successfully',
      successfullyUpdated: 'Split configuration updated successfully',
      successfullyDeleted: 'Split configuration removed successfully',
    },
  },
};

export default brSplit;
